<template>
    <div v-if="subscription?.length > 0" class="mt-4 border-gray-200 border-b border-t border-r border-l rounded-lg">
      <Table 
    :headers="headers" 
    :data="subscription" 
    :row-key="[
      'valid_from',
      'subscription_code',
      'offerName',
      'valid_from',
      'valid_to',
      'is_active']" 
      :current-page="currentPage" 
      :isLoading="isLoading" 
      :per-page="perPage"
      >
      <template #offerName="{ row }">
        {{row.orderlines?.offers?.long_name || '-'}}
        </template>
        <template #header-created-subscripbe="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}   
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #header-valid-to-subscripbe="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}   
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #is_active="{ row }">
          <div style="width: 100px">
            <span v-if="isActive(row.valid_to)" class="bg-green-100 px-2 py-1 rounded-lg text-sm text-green-800">
              Active
            </span>
            <span v-else class="bg-gray-100 text-gray-800 px-2 py-1 text-sm rounded-lg">
              Inactive
            </span>
          </div>
        </template>
        <template #created="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #valid_from="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #valid_to="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
      </Table>
    </div>
      <div  v-else class="relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
  <table v-if="!isLoading" class="min-w-full h-64 text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center uppercase">
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">No</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">created Date</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">subscription code</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Offer Name
            </th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">valid from Date</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">valid to Date</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Status</th>
          </tr>
        </thead>
        <tbody class="bg-white w-full">
          <tr>
            <td colspan="7" class="text-center py-8 text-gray-500">
            <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 574px;">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import Table from '@/components/form/table'
  import { mapActions } from "vuex";

  export default {
    components: {
      Table
    },
    name: "Subscription",
    props: {
      user: {
        type: String,
        required: true,
      },
      subscription: {
        type: Array,
        required: true,
      },
      perPage: {
      type: Number,
      required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      isLoading: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        headers: [
        { label: 'No', key: '' },
        { label: 'created Date', key: ''},
        { label: 'subscription code', key: '' },
        { label: 'Offer Name', key: ''},
        { label: 'valid from Date', key: 'valid_from', slotHeader:'header-created-subscripbe'},
        { label: 'valid to Date', key: 'valid_to', slotHeader:'header-valid-to-subscripbe'},
        { label: 'Status', key: '', } 
      ],
      sorts:[],
      };
    },
    
    methods: {
      ...mapActions("users", ["fetchUserSubscription"]),
      isValid(date) {
      let now = Date.now();
      if (moment(date).isSameOrAfter(now)) {
        return true;
      }

      return false;
    },
    isActive(date) {
      return moment(date).isAfter(moment());
    },
      sortBy(column) {
        let existingIndex = this.sorts.findIndex(s => s.column === column);

  if (existingIndex >= 0) {
    this.sorts[existingIndex].order =
      this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

    const [item] = this.sorts.splice(existingIndex, 1);
    this.sorts.unshift(item);
  } else {
    this.sorts.unshift({ column, order: "asc" });
  }

      let sortString = this.sorts
        .map(s => `${s.column}_${s.order}`)
        .join(',');
        this.$emit("sort-data", sortString);
        let email = this.$route.params.id;
      let data = {
        email: email,
        page: this.currentPage,
        limit: this.perPage,
        sort: sortString
      };
      this.fetchUserSubscription(data);
    },
       formatDate(tgl) {
  return {
    date: moment(tgl).format('DD MMM YY'),
    time: moment(tgl).format('HH:mm:ss'),
  };
},
    }
  };
  </script>
  
  <style scoped>
  .subscripbe {
    max-height :600px;
    overflow-y: auto;
  }
  </style>
  